/**
 * Application configuration.
 * In development, VITE_API_URL is empty and the Vite proxy handles /api requests.
 * In production, set VITE_API_URL to the backend URL (e.g. https://your-app.railway.app).
 */
export const API_URL = import.meta.env.VITE_API_URL || "";

/**
 * GitHub repository URL for feedback/issues.
 * Update this when the repo is set up.
 */
export const GITHUB_REPO = import.meta.env.VITE_GITHUB_REPO || "https://github.com/levipl123-crypto/OpenAssetBuilder_V0.1";

/**
 * App version displayed in the UI.
 */
export const APP_VERSION = "0.1.0-preview";
